var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{attrs:{"id":"app"}},[_c('HeaderItem01'),_c('v-content',{attrs:{"transition":"slide-x-transition"}},[_c('router-view')],1),_c('FooterItem01')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }